import React from 'react';
import { observer } from 'mobx-react';
import { IconType, ButtonProps, Icon } from '@routific/hive';
import { DeleteIcon } from '@routific/hive/v5';
import type { V5ButtonHierarchy } from '@routific/hive/v5';
import { useTranslation } from 'react-i18next';
import ActionButton, { CommonActionTypes, ButtonTypes } from '../../../shared/ActionButton';
import { RouteProps } from '../../../../store/mst/utils/getRoutesProps';
import useDeleteRoute from '../../../../hooks/useDeleteRoute';

interface Props {
  routeProps: RouteProps;
  type?: ButtonTypes;
  buttonProps?: ButtonProps;
  // Render as a v5 Button, for the v5 chrome (the page footer's action band).
  v5?: boolean;
  v5Hierarchy?: V5ButtonHierarchy;
}

const DeleteRouteButton: React.FC<Props> = ({
  routeProps, type, buttonProps,
  v5,
  v5Hierarchy,
}) => {
  const { t } = useTranslation('components');
  const handleDeleteRoute = useDeleteRoute();

  const {
    uuids, isDispatched, isLocked, disabled, isDeleting,
  } = routeProps;

  const handleDelete = () => handleDeleteRoute(uuids);

  const getTooltipText = () => {
    if (isDispatched) {
      return t('publish.tooltip.deletePublished');
    }
    if (isLocked) {
      return t('publish.tooltip.routeLocked');
    }
    if (type === ButtonTypes.BUTTON) {
      return t('moreActionsButton.route.button.delete.tooltip.button');
    }
    return undefined;
  };

  return (
    <ActionButton
      v5={v5}
      v5Hierarchy={v5Hierarchy}
      v5Icon={<DeleteIcon size="md" />}
      name={CommonActionTypes.DELETE}
      tooltipProps={{
        title: getTooltipText(),
      }}
      type={type}
      disabled={disabled || isDeleting}
      menuItemProps={{
        danger: true,
        onClick: handleDelete,
        icon: <Icon icon={IconType.Delete} />,
      }}
      menuItemText={t('moreActionsButton.route.button.delete.text')}
      buttonProps={{
        icon: IconType.Delete,
        danger: true,
        style: { pointerEvents: 'auto' },
        onClick: handleDelete,
        ...buttonProps,
      }}
    />
  );
};

export default observer(DeleteRouteButton);
